module.exports = __webpack_public_path__ + "static/before-882c4d8b8812888c63e1df088c20e66d.png";